import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import SiteLayout from '../../../layouts/SiteLayout/SiteLayout';
import ServerErrorSection from '../../../siteBaseSections/ServerErrorSection/ServerErrorSection';

export default function ServerErrorView() {
  const { t } = useTranslation();
  const { meta: { title: metaTitle } = {}, data: { title: dataTitle } = {} } =
    useSelector((state) => state.siteHeader);
  const title = metaTitle || dataTitle;
  const helmetTitle = title
    ? `${t('event.error')} | ${title}`
    : t('event.error');

  return (
    <SiteLayout helmet={{ title: helmetTitle }}>
      <ServerErrorSection />
    </SiteLayout>
  );
}
